import axios from 'axios'

export const Fonts = {
    title:'Adelia',
    subtitle:'Vendya',
    primary:'Inter',
    
}

export const Colors = {
    background:'#FBF1EC',
    light: '#E06D2A',
    foreground: '#B27D5D',
    pastel: '#EAD2C4',
    offWhite: '#FBF1EC',
    offWhite2: '#F7F3F0',
    pastelLight:'#f1dfd5'
}

export function dateStringToTimestamp(dateString:any){
    const [day, month, year] = dateString.split('/').map(Number)
    const date = new Date(year, month-1, day)
    return(date.getTime())
}

export function replaceForbiddenChars(str:any) {
  return str.replace(/[^a-zA-Z0-9.\s]/g, '');
}

const BASE_URL = 'https://api-4qwtgtns4a-uc.a.run.app/'

export async function getDocs(collection:string, where:any=[]){
        const options = {
            url:BASE_URL+'firestore',
            method:'POST',
            headers: {
                accept: 'application/json',
                'content-type': 'application/json',
            },
            data:
            where.length===0?
            {
                type:'getDocs',
                collection:collection,
            }
            :
            {
                type:'getDocs',
                collection:collection,
                where:where
            }
        }
        const res = await axios.request(options)
        .then((res)=>{
            return(res.data.docs)
        })
        .catch((err)=>{
            return(undefined)
        })
        return(res)
}